<template>
    <div class="u-padding">
        <new-dns-record :domain="domain" class="u-margin-bottom-narrow" />

        <table class="table dns-zones__table" cellspacing="0">
            <thead class="dns-zones__table-head">
                <tr>
                    <th>{{ trans('page.dns.table.type') }}</th>
                    <th>{{ trans('page.dns.table.name') }}</th>
                    <th>{{ trans('page.dns.table.content') }}</th>
                    <th>{{ trans('page.dns.table.ttl') }}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <dns-record
                    v-for="(record, recordIndex) in records"
                    :key="recordIndex"
                    :record="record"
                    :recordIndex="recordIndex"
                    :domain="domain"
                    :updating="updating"
                />
            </tbody>
        </table>
    </div>
</template>

<script>
import DnsRecord from './DnsRecord.vue';
import NewDnsRecord from './NewDnsRecord.vue';
import '../styles/_dns-zones.scss';

export default {
    components: {
        DnsRecord,
        NewDnsRecord
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        records: {
            type: Array,
            default: () => []
        },
        updating: {
            type: Boolean,
            default: false
        }
    }
};
</script>
